import { ElementRef, NgZone, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ReorderableColumn as ReorderableColumnBase } from 'prime-ng-old/table';
import { ReorderableRowHandle as ReorderableRowHandleBase } from 'prime-ng-old/table';
import { ReorderableRow as ReorderableRowBase } from 'prime-ng-old/table';
import { PARENT_TABLE } from '../table.injection-token';
import * as i0 from "@angular/core";
// required because of the constructor needing reference to ui-table component
export let ReorderableColumn = /*#__PURE__*/(() => {
  class ReorderableColumn extends ReorderableColumnBase {
    constructor(platformId, renderer, dt, el, zone) {
      super(platformId, renderer, dt, el, zone);
      this.dt = dt;
      this.el = el;
      this.zone = zone;
    }
    isEnabled() {
      return this.uiReorderableColumnDisabled !== true;
    }
    static {
      this.ɵfac = function ReorderableColumn_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReorderableColumn)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: ReorderableColumn,
        selectors: [["", "pReorderableColumn", ""]],
        inputs: {
          uiReorderableColumnDisabled: "uiReorderableColumnDisabled"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ReorderableColumn;
})();
export let ReorderableRowHandle = /*#__PURE__*/(() => {
  class ReorderableRowHandle extends ReorderableRowHandleBase {
    constructor(el) {
      super(el);
      this.el = el;
    }
    static {
      this.ɵfac = function ReorderableRowHandle_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReorderableRowHandle)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: ReorderableRowHandle,
        selectors: [["", "pReorderableRowHandle", ""]],
        inputs: {
          index: [0, "pReorderableRowHandle", "index"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ReorderableRowHandle;
})();
// required because of the constructor needing reference to ui-table component
export let ReorderableRow = /*#__PURE__*/(() => {
  class ReorderableRow extends ReorderableRowBase {
    constructor(renderer, dt, el, zone) {
      super(renderer, dt, el, zone);
      this.dt = dt;
      this.el = el;
      this.zone = zone;
    }
    isEnabled() {
      return this.pReorderableRowDisabled !== true;
    }
    static {
      this.ɵfac = function ReorderableRow_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ReorderableRow)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: ReorderableRow,
        selectors: [["", "pReorderableRow", ""]],
        inputs: {
          index: [0, "pReorderableRow", "index"],
          pReorderableRowDisabled: "pReorderableRowDisabled"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ReorderableRow;
})();